/** The longest window the `analytics` function charts at once (its range.ts agrees). */
export const MAX_RANGE_DAYS = 366;

/**
 * Whether the `analytics` function takes a zone as the browser names it: UTC, or
 * an Area/Location name (its range.ts `canonicalTimeZone`). A browser names its
 * zone that way unless the system clock is set to a bare offset ("-05:00"),
 * which Postgres would read the other way round, or to nothing it can name
 * ("Etc/Unknown").
 */
export function isServerTimeZone(zone: string): boolean {
  if (zone !== "UTC" && !zone.includes("/")) return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: zone });
    return true;
  } catch {
    return false;
  }
}

const MS_PER_DAY = 86_400_000;

/** Days from `from` to `to` (YYYY-MM-DD), both ends counted: a single day is 1. */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / MS_PER_DAY) + 1;
}

/**
 * Why a picked window cannot be charted, or null when it can — so a window the
 * server would refuse is never sent. The date picker already disables future
 * days and keeps the ends in order, which leaves the length. Worded as the
 * Angular page words it.
 */
export function customRangeProblem({ from, to }: { from: string; to: string }): string | null {
  const days = daysBetween(from, to);
  return days > MAX_RANGE_DAYS
    ? `That window is ${days.toLocaleString("en-US")} days; ${MAX_RANGE_DAYS} is the most that can be charted at once.`
    : null;
}
